import { 
  mapState as ms,
  mapMutations as mm,
  mapActions as ma,
  mapGetters as mg,
  createNamespacedHelpers
} from 'vuex'
export default function (nameSpace, { states = [], actions = [], mutations = [], getters = [] }) {
  if (nameSpace) {
    const {mapState, mapActions, mapMutations, mapGetters} = createNamespacedHelpers(nameSpace)
    return {
      computed: {
        ...mapState(states),
        ...mapGetters(getters)
      },
      methods: {
        ...mapActions(actions),
        ...mapMutations(mutations)
      }
    }
  }
  return {
    computed: {
      ...ms(states),
      ...mg(getters)
    },
    methods: {
      ...ma(actions),
      ...mm(mutations)
    }
  }
}